import * as React from "react";
import Component from "../../AbstractComponent";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import ActivityTemplateCreateWillMount from "../../../Middleware/Middlewares/ActivityTemplateCreateWillMount";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { CoachDialogNewExecutor } from "../../Partials/Dialog/CoachDialogNewExecutor";
import { TaskTemplateInterface } from "../../../Entity/Entities/Task/TaskTemplateInterface";
import TaskTemplateFactory from "../../../Entity/Factories/TaskTemplateFactory";
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class ActivityTemplateCreate extends Component {
  protected person: PersonInterface;
  public instructionsField;

  public state = {
    name: "",
    hasModifiedData: false,
    openLeavePrompt: false,
    taskTemplates: [],
    activeTemplateId: 0,
    taskToDeleteId: 0,
    activeTemplate: null,
    isDeleteTaskPopupOpen: false,
    nameEmpty: false,
    errorTemplates: [],
    isSaving: false,
    selectedTaskTemplate: null,
    openPreTaskExecutorCoachDialog: false,
    executorType: "person",
    executorTypeСhoose: true,
    openTaskExecutorCoachDialog: false
  };

  protected middlewares: MiddlewareInterface[] = [
    ActivityTemplateCreateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);
  }

  public createTaskTemplate = () => {
    const taskTemplate = {
      name: this.trans("new-task"),
      details: "",
      executorId: null,
      daysToExecute: 0
    };

    const taskTemplates = [...this.state.taskTemplates];

    const previousTaskTemplate = taskTemplates[taskTemplates.length - 1];
    const previousTaskTemplateName = previousTaskTemplate ? previousTaskTemplate.name : "";
    const previousTaskTemplateNumber = parseInt(previousTaskTemplateName.replace(this.trans("new-task"), ""));
    let newTaskTemplateName = `${this.trans("new-task")} ${previousTaskTemplateNumber + 1}`;

    if (previousTaskTemplateName === this.trans("new-task")) {
      newTaskTemplateName = `${this.trans("new-task")} 2`;
      taskTemplate.name = newTaskTemplateName;
    }

    if (previousTaskTemplateName.includes(this.trans("new-task"))) {
      taskTemplate.name = newTaskTemplateName;
    }

    taskTemplates.push(taskTemplate);

    this.setState({
      taskTemplates: [...taskTemplates],
      activeTemplate: {...taskTemplate},
      activeTemplateId: taskTemplates.length - 1,
      hasModifiedData: true
    });

    if(this.instructionsField){
      this.instructionsField.focus();
    }
  }

  public save = () => {
    if(!this.state.name) {
      this.setState({nameEmpty: true});
      return;
    }

    const taskTemplates = [...this.state.taskTemplates];

    if(taskTemplates.some(template => !template.name)) {
      const errorTemplates = [];
      taskTemplates.forEach((template, index) => {
        if(!template.name) {
          errorTemplates.push(index);
        }
      });

      return this.setState({errorTemplates: [...errorTemplates]});
    }

    taskTemplates.forEach(template => {
      if (template.daysToExecute === "") {
        template.daysToExecute = null;
      }
    })

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_ACTIVITY_TEMPLATE_CREATE_START,
        payload: {
          name: this.state.name,
          taskTemplates: [...taskTemplates]
        },
        onSuccess: (_activityTemplate, taskTemplates) => {
          taskTemplates.forEach(taskTempl => {
            const taskTemplate: TaskTemplateInterface = TaskTemplateFactory.create(taskTempl);
  
            this.props.dispatch({
              type: Constants.GLOBAL_TASK_TEMPLATE_CREATE_SUCCESS,
              payload: {
                taskTemplate: taskTemplate
              }
            });
          })

          this.redirectBack();
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public choosedTaskToDelete = (templateId: number) => {
    const templates = [...this.state.taskTemplates];
    const template = templates.splice(templateId, 1)[0];

    this.setState({isDeleteTaskPopupOpen: true, taskToDeleteId: templateId, selectedTaskTemplate: template})
  }

  public selectPerson = (person: PersonInterface): void => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.executorId = person && person.id;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: true});
  }

  public clearPerson = (): void => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.executorId = null;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: true});
  }

  public changeDays = (event) => {
    const days = Number.parseInt(event.target.value);

    this.setState({
      daysToExecute: days,
      hasModifiedData: true
    });
  }

  public setActivityTemplateName = (event) => {
    const name = event.target.value;

    this.setState({name: name, nameEmpty: false, hasModifiedData: true});
  }

  public setTemplateName = (event) => {
    const name = event.target.value;

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.name = name;
    templates[this.state.activeTemplateId] = {...template}

    const errorTemplates = [...this.state.errorTemplates];
    errorTemplates.forEach((id, index) => {
      if (id === this.state.activeTemplateId) {
        errorTemplates.splice(index, 1);
      }
    });

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], errorTemplates: [...errorTemplates], hasModifiedData: true});
  }

  public setTemplateDetails = (event) => {
    const details = event.target.value;

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.details = details;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: true});
  }

  public setTemplateDays = (event) => {
    const days = Number.parseInt(event.target.value);

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.daysToExecute = days;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: true});
  }

  public deleteTask = (templateId: number) => {
    const templates = [...this.state.taskTemplates];

    templates.splice(templateId, 1);

    const activeTemplate = {...templates[0]};

    this.setState({
      taskTemplates: [...templates],
      activeTemplateId: 0,
      activeTemplate: activeTemplate,
      errorTemplates: [],
      hasModifiedData: true
    });
    if(this.instructionsField){
      this.instructionsField.focus();
    }
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/executor-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.executorType}
            onChange={this.chooseExecutorType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="user"
              label={this.trans("coach/executor-radiobutton/user")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/executor-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        {/* <div>
          {this.trans("coach/executor-scenario/company-step/first-info2")}
        </div> */}
      </div>
    )
  }

  public chooseExecutorType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      executorType: choice,
      executorTypeСhoose: true
    });
  }

  public onCloseCoach = () => {
    this.setState({
      openPreTaskExecutorCoachDialog: false,
      executorType: "person",
      // executorTypeСhoose: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public setExecutorFromCoach = (executor) => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.executorId = executor && executor.id;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: true});
  }

  public openFirstStep = () => {
    this.setState({
      executorType: this.state.executorTypeСhoose ? this.state.executorType : "person",
      openPreTaskExecutorCoachDialog: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public openTaskExecutorCoach = () => {
    if(this.state.executorType !== "user" || this.person.role && this.person.role.getRoleId() === 6) {
      this.setState({
        openPreTaskExecutorCoachDialog: false,
        openTaskExecutorCoachDialog: true
      })
    } else {
        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("coach/executor-scenario/user-step/first-error"),
            type: "error"
          }
        });
        return;
    }
  }

  public render() {
    const rightBlockWidth = "340px";
    return (
      <div className="state-app">
        <div className="box component-activity full-width box-full has-details-page-header">
          <div className="component-header has-back-button align-center">
            <div className="back-arrow-wrapper" onClick={this.redirectBack}>
              <div className="icon icon-ic-arrow-back icon-color"></div>
            </div>
            <h1>{this.trans("activitytemplatecreate-addactivity-title")}</h1>
            <div className="button-container">
              <Button
                color="primary"
                onClick={this.cancel.bind(this)}
                style={{marginRight: "20px"}}
              >
                {this.trans("button-cancel")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.save}
                disabled={this.state.isSaving}
              >
                {this.state.isSaving === true ? this.trans("button-saving") : this.trans("button-create")}
              </Button>
            </div>
          </div>

          <div className="component-wrapper no-margin-top">
            <div className="component">
              <Card className="card" style={{padding: "20px"}}>
                <p style={{color: "#333", margin: "0 0 10px 0"}}>
                  {this.trans("determine-name-for-activity")}
                </p>
                <div className="hint-styles-dialog" style={{color: "#333", margin: "0px"}}>
                  {this.trans("determine-name-for-activity-2")}
                </div>
              </Card>
            </div>
          </div>

          <div className="component-wrapper no-margin-top">
            <div className="component">
              <Card className="card" style={{padding: "20px"}}>
                <div style={{maxWidth: "270px"}}>
                  <TextField
                    autoComplete="off"
                    id="activityTemplateName"
                    name="activityTemplateName"
                    className="form-element full-size"
                    type="text"
                    label={this.trans("page/activity-field/name-label")}
                    value={this.state.name}
                    onChange={this.setActivityTemplateName}
                    autoFocus={true}
                    variant="standard"
                    error={this.state.nameEmpty && !!this.trans("this-field-is-required")}
                  />
                  {!!this.state.nameEmpty && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
                </div>
              </Card>
            </div>
          </div>

          <div className="component-wrapper">
            <Card className="card no-padding">
              <div className="label-container">
                <h3 className="card-title">
                  {this.trans("tasks")}
                </h3>
                <Button
                  color="primary"
                  onClick={this.createTaskTemplate}
                  className="add-task"
                >
                  {this.trans("button-add-task")}
                </Button>
              </div>
              <div className="task-tempalte-wrapper" style={{display: "flex"}}>
                <div className="left-block"
                  style={{
                    minHeight: "300px",
                    width: "30%",
                    borderRight: "1px solid rgba(0, 0, 0, 0.1)"
                  }}
                >
                  {
                    this.state.taskTemplates.length === 0 && (
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "8px"}}>
                          <div className="icon icon-ic-task" style={{color: "#dcdbdc"}}></div>
                        </div>
                        <div style={{fontSize: "22px", fontWeight: "bold", color: "#dcdbdc", marginBottom: "8px"}}>{this.trans("no-tasks-created")}</div>
                      </div>
                    )
                  }
                  {
                    this.state.taskTemplates.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "flex-start"
                        }}
                      >
                        {
                          this.state.taskTemplates.map((taskTemplate: TaskTemplateInterface, key: number) => {
                            return (
                              <div key={key} className={this.state.activeTemplateId === key ? "with-active-gray-background" : "with-active-white-background"}
                                style={{
                                  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  cursor: "pointer",
                                  backgroundColor: this.state.errorTemplates.some(index => index === key) ? "#ffa4a4" : ""
                                }}
                                onClick={() => {
                                  this.setState({activeTemplate: {...taskTemplate}, activeTemplateId: key});
                                  if(this.instructionsField){
                                    this.instructionsField.focus();
                                  }
                                }
                              }
                              >
                                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                  <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px"}}>
                                    <div className="icon icon-ic-task" style={{color: "#dcdbdc"}}></div>
                                  </div>
                                  <div style={{fontSize: "14px", color: "#404040", lineHeight: "24px"}}>{taskTemplate.name}</div>
                                </div>
                                <div>
                                  <div
                                    onClick={() => this.choosedTaskToDelete(key)}
                                    style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                                    <IconButton  aria-label="Delete" className="icon-button-wrapper">
                                      <div className="icon icon-ic-remove"></div>
                                    </IconButton>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        }
                      </div>
                    )
                  }
                </div>
                <div className="right-block" style={{paddingLeft: "20px"}}>
                  {this.state.taskTemplates.length > 0 && (
                    <div style={{width: rightBlockWidth}}>
                      <TextField
                        autoComplete="off"
                        className="form-element full-size"
                        type="text"
                        label={this.trans("label-description")}
                        value={this.state.activeTemplate ? this.state.activeTemplate.name : ""}
                        onChange={this.setTemplateName}
                        autoFocus={true}
                        inputRef={(input) => { this.instructionsField = input; }}
                        variant="standard"
                        multiline
                        rowsMax="25"
                        rows="1"
                        error={this.state.errorTemplates.some(index => index === this.state.activeTemplateId) && !!this.trans("this-field-is-required")}
                      />
                      {this.state.errorTemplates.some(index => index === this.state.activeTemplateId) && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

                      <div style={{margin: "-10px 0"}}>
                        <PersonLookup
                          {...this.props}
                          isInlineBlock={true}
                          width={rightBlockWidth}
                          ref="PersonLookup"
                          floatingLabelText={this.trans("to-do-by") + this.trans("field/optional")}
                          labelText={this.trans("to-do-by") + this.trans("field/optional")}
                          onSelect={this.selectPerson}
                          onClear={this.clearPerson}
                          autoSelectId={this.state.activeTemplate.executorId}
                          buttonLabel={this.trans("button-add-executor")}
                          noResultText={this.trans("textfield-no-executor-found-click-add")}
                          templateFor={"executor"}
                          includeUsers={true}
                          shouldOpenCoachModal={true}
                          openTaskExecutorCoachDialog={() => this.setState({openPreTaskExecutorCoachDialog: true})}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "activityTemplateCreate", "executor")}
                        />
                      </div>

                      <TextField
                        autoComplete="off"
                        className="form-element"
                        label={this.trans("days-to-execute") + this.trans("field/optional")}
                        value={this.state.activeTemplate ? this.state.activeTemplate.daysToExecute : ""}
                        onChange={this.setTemplateDays}
                        type="number"
                        style={{width: rightBlockWidth}}
                        variant="standard"
                        error={this.getErrorFor("daysToExecute")}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-task")}
          content={this.trans("you-are-about-to-delete-task", {name: this.state.selectedTaskTemplate && this.state.selectedTaskTemplate.name ? this.state.selectedTaskTemplate.name : ""})}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteTaskPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteTaskPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteTaskPopupOpen: false }); this.deleteTask(this.state.taskToDeleteId) }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/executor-title")}
          content={this.getCoachContent()}
          innerDialogClasses="dialog-assistant coach-executor"
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPreTaskExecutorCoachDialog}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              openPreTaskExecutorCoachDialog: false,
              // ownerType: "",
              // ownerTypeСhose: false
            });
          }}
          onSave={this.openTaskExecutorCoach}
          // diableContinueButton={!this.state.ownerTypeСhose}
        />

        <CoachDialogNewExecutor
          {...this.props}
          openTaskExecutorCoachDialog={this.state.openTaskExecutorCoachDialog}
          type={this.state.executorType}
          setExecutor={this.setExecutorFromCoach}
          openFirstStep={this.openFirstStep}
          onCloseCoach={this.onCloseCoach}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.companyCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  ActivityTemplateCreate
);
